import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

const writeText = async (text) => {
  try { await navigator.clipboard.writeText(text); return; } catch { /* fall back below */ }
  const ta = Object.assign(document.createElement('textarea'), { value: text });
  ta.style.cssText = 'position:fixed;opacity:0';
  document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove();
};

export const CopyButton = ({ text, label, testId }) => {
  const [done, setDone] = useState(false);
  const copy = async (e) => {
    e.stopPropagation();
    await writeText(text);
    setDone(true); setTimeout(() => setDone(false), 1500);
  };
  return (
    <button type="button" data-testid={testId} onClick={copy} title={label}
      className={`inline-flex items-center gap-1 rounded-md px-1.5 py-1 text-[11px] font-medium normal-case tracking-normal transition-colors ${done ? 'text-emerald-600' : 'text-neutral-500 hover:text-brand hover:bg-neutral-100 dark:hover:bg-neutral-800'}`}>
      {done ? <Check size={13} /> : <Copy size={13} />}{done ? 'Copied' : label}
    </button>
  );
};
